import { createApp } from 'vue';
import cmpBundlesSearch from '../vue/BundlesSearch.vue';

window.BundlesSearch = (function(){
	const component = createApp(cmpBundlesSearch, {
		bundleSearchModel: window.bundleSearchModel,
		bundleSearchStartup: window.bundleSearchStartup
	});
	delete window.bundleSearchModel;
	delete window.bundleSearchStartup;
	return component.mount('#component-bundles-search');
})();
